// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const StyledRightSection = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	gap: var(--size-grid);
`;

// #####################################################
